module.exports = __webpack_public_path__ + "img/region_midwest.138ae284.svg";